import type { Config } from "wagmi"
import { readContract } from "@wagmi/core"

import { frontendDefaultPairInfoAbi } from "@/domains/abis"
import { LcAddress } from "@/domains/core"
import { MinimalPoolStore } from "@/domains/minimal-pool/minimal-pool-store"

export type DefaultInfoPairValues = {
  address: LcAddress
  totalSupply: bigint
  reserve0: bigint
  reserve1: bigint
  gaugeTotalSupply: bigint
  gaugeReserve0: bigint
  gaugeReserve1: bigint
}

export const frontendDefaultInfoPairs = async (
  config: Config,
  scalensDefaultInfoPairs: LcAddress,
  pools: Array<MinimalPoolStore>,
): Promise<Array<DefaultInfoPairValues>> => {
  // map ids to pools for _proper_ LC address based lookup - no id loop "hit and hope"
  const poolIdMap = new Map<string, MinimalPoolStore>()
  for (const pool of pools) {
    poolIdMap.set(pool.address.toString(), pool)
  }

  // make the query (requires IDs - soon to be an array of addresses!)
  const addresses = pools.map((pool) => pool.address.toViemAddress())

  const response = await readContract(config, {
    abi: frontendDefaultPairInfoAbi,
    address: scalensDefaultInfoPairs.toViemAddress(),
    functionName: "infoPairsStruct",
    args: [addresses],
  })

  const results = []
  for (let i = 0; i < response[1].length; i++) {
    const item = response[1][i]
    const poolAddress = new LcAddress(item?.A as string)
    const pool = poolIdMap.get(poolAddress.toString())

    if (!item || !pool) {
      //   console.log(contractResponse)
      //   console.log(pool)
      console.error("pool not matched", i, poolAddress)
      continue
    }

    const pairAddress = item.A
    const [totalSupply, reserve0, reserve1, gaugeTotalSupply, gaugeReserve0, gaugeReserve1] = item.N
    results.push({
      address: new LcAddress(pairAddress),
      totalSupply,
      reserve0,
      reserve1,
      gaugeTotalSupply,
      gaugeReserve0,
      gaugeReserve1,
    })
  }
  return results
}
